import React from 'react';
import FilterMetadata from '../../components/FirestoreTable/FilterMetadata';
import TripStatus from '../../models/scoopm/TripStatus';
import Table from './Table';

export default function Active() {
  return (
    <Table
      id="DISPATCH_PORTAL_ACTIVE"
      filters={[
        Object.assign(FilterMetadata.status, {
          value: TripStatus.notDone().map(s => s.rawValue),
        }),
      ]}
    />
  );
}
